import { components } from "@certn/api/generated-schemas/applicant-portal";
import { useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function CancelledCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="cancelled"
      tagText={t("Cancelled")}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
